/* eslint-disable */
import convertList from '../convertList';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
export default function(config) {
    const moreConfig = {
        totalState: false
    };
    const params = {
        page: config.pageIndex ? Number(config.pageIndex) + 1 : 0,
        pageSize: 999,
        keyword: config.name,
        needQQ: true
    };
        return new Promise((resolve, reject) => {
            searchStaff(params).then(res=>{
                if(res.code !== 0 ){
                    reject("搜索组织架构数据获取失败", res.code)
                }
                let {page, staffs, total} = res.data
                let users = staffs.map(x=>{
                    return {
                        ...x,
                        colleagueInfo:{
                            account: x.account
                        },
                        id: x.kfext
                    }
                })

                let list = convertList(
                    users,
                    {
                        list: 'list',
                        groupName: 'name',
                        total: 'memberTotal'
                    },
                    moreConfig
                )

                resolve({
                    list
                })

            })
        })



}


function searchStaff(params) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v1/org/searchStaff`, params);
}
